<router-outlet></router-outlet>

<app-loading-panel [visible]="loading"></app-loading-panel>
